import React from 'react'

export default () =>
  <svg width="22px" height="22px" viewBox="0 0 20 26" version="1.1">
    <g fill="none" strokeWidth="2px">
      <path
        stroke="currentColor"
        d="M20,5.9076623 L17.928656,19.3038508 C17.7931211,20.2116815 17.1558376,20.9811671 16.202536,20.9811671 L3.79746398,20.9811671 C2.84416243,20.9811671 2.24077993,20.161362 2.07134399,19.3038508 L0,5.9076623"
        id="Stroke-1"
      />
      <path
        stroke="currentColor"
        d="M15,6.17647059 L11.3420916,9.47367187 C10.6154075,10.1286974 9.38459248,10.1286974 8.65790845,9.47367187 L5,6.17647059"
        id="Stroke-3"
      />
      <path stroke="currentColor" d="M10,0 L10,9.5942492" id="Stroke-5" />
    </g>
  </svg>



// WEBPACK FOOTER //
// ./src/icons/downloadIcon.js